export default __webpack_public_path__ + "static/media/technic.e9badcae.svg";